import screenfull from "screenfull"

export default {
  namespaced: true,
  state: {
    //全屏激活
    active: false
  },
  actions: {
    //初始化监听
    listen({ commit }) {
      return new Promise(resolve => {
        if (screenfull.enabled) {
          screenfull.on("change", () => {
            if (!screenfull.isFullscreen) {
              commit("set", false)
            }
          })
        }
        resolve()
      })
    },
    //切换全屏
    toggle({ commit }) {
      return new Promise(resolve => {
        if (screenfull.isFullscreen) {
          screenfull.exit()
          commit("set", false)
        } else {
          screenfull.request()
          commit("set", true)
        }
        resolve()
      })
    }
  },
  mutations: {
    set(state, active) {
      state.active = active
    }
  }
}
